import clsx from "clsx";

import { Button } from "../Button";
import Spinner from "../Spinner";

import type { ReactNode } from "react";

interface CaptureDialogPanelProps {
  label: string;
  children: ReactNode;
  panelAction?: {
    label: string;
    action: () => void;
    icon?: ReactNode;
  };
  panelActionDisabled?: boolean;
  onImageSubmitInProgess?: boolean;
  renderTopRight?: () => ReactNode;
  renderSubmitShortcut?: () => ReactNode;
  renderBottomRight?: () => ReactNode;
}

export const CaptureDialogPanel = ({
  label,
  children,
  panelAction,
  panelActionDisabled = false,
  onImageSubmitInProgess,
  renderTopRight,
  renderSubmitShortcut,
  renderBottomRight,
}: CaptureDialogPanelProps) => {
  return (
    <div className="capture-dialog-panel">
      <div className="capture-dialog-panel__header">
        <label>{label}</label>
        {renderTopRight?.()}
      </div>

      {children}
      <div
        className={clsx("capture-dialog-panel-button-container", {
          invisible: !panelAction,
        })}
        style={{ display: "flex", alignItems: "center" }}
      >
        <Button
          className="capture-dialog-panel-button"
          onSelect={panelAction ? panelAction.action : () => {}}
          disabled={panelActionDisabled || onImageSubmitInProgess}
        >
          <div className={clsx({ invisible: onImageSubmitInProgess })}>
            {panelAction?.label}
            {panelAction?.icon && <span>{panelAction.icon}</span>}
          </div>
          {onImageSubmitInProgess && <Spinner />}
        </Button>
        {!panelActionDisabled &&
          !onImageSubmitInProgess &&
          renderSubmitShortcut?.()}
        {renderBottomRight?.()}
      </div>
    </div>
  );
};
